import { parseHexColor, rgbToHex } from './parseHexColor';

/**
 * Mittelt Farben kanalweise und liefert das Ergebnis als `#RRGGBB`.
 *
 * Unlesbare Werte werden übersprungen statt still mitverrechnet – früher setzte die Funktion
 * ein führendes `#` voraus, sodass z.B. "F2F2F8" (fast weiß) als "#2f2f08" (fast schwarz)
 * herauskam und die daraus abgeleitete Textfarbe kippte. Ist keine Farbe lesbar, kommt ein
 * leerer String zurück; die Aufrufer behandeln das über ihren eigenen Fallback.
 */
export const averageColor = (colors: string[]): string => {
  const parsed = colors.map(parseHexColor).filter((rgb) => rgb !== null);
  if (parsed.length === 0) return '';

  const channel = (index: number) => Math.round(parsed.reduce((sum, rgb) => sum + rgb[index], 0) / parsed.length);

  return rgbToHex([channel(0), channel(1), channel(2)]);
};
